import React, { useEffect, useState } from "react";
import { Modal, Slider, Checkbox } from "antd";
import { formatGlobalPrice } from "../../../../../config/Global";
import { set } from "lodash";
import { CONSTANT } from "../../../../../config/Constant";

interface FilterModalProps {
  open: boolean;
  onClose: () => void;
  sortOptions: { label: string; value: string }[];
  sortOrder: string;
  sortBy: string;
  setSortOrder: (val: string) => void;
  setSortBy: (val: string) => void;
  categoryList: { id: string; full_name: string; code: string }[]; // Added code
  selectedCategories: string[];
  setSelectedCategories: (val: string[]) => void;
  setSelectedCategory: (val: string) => void; // Add this prop
  setShowName: (val: string) => void; // Add this prop
  salaryRange: [string, string];
  setSalaryRange: (val: [string, string]) => void;
  handleClearAll: () => void;
  setShowFilterCount: (val: boolean) => void; // Add this prop
}

const FilterModal: React.FC<FilterModalProps> = ({
  open,
  onClose,
  sortOptions,
  sortOrder,
  sortBy,
  setSortOrder,
  setSortBy,
  categoryList,
  selectedCategories,
  setSelectedCategories,
  salaryRange,
  setSalaryRange,
  handleClearAll,
  setSelectedCategory,
  setShowName,
  setShowFilterCount,
}) => {
  const handleSalaryChange = (value: number[]) => {
    setTempSalaryRange([String(value[0]), String(value[1])]);
  };

  const [tempSortBy, setTempSortBy] = useState(sortBy);
  const [tempSortOrder, setTempSortOrder] = useState(sortOrder);
  const [tempCategories, setTempCategories] = useState(selectedCategories);
  const [tempSalaryRange, setTempSalaryRange] = useState(salaryRange);

  useEffect(() => {
    setTempSortBy(sortBy);
    setTempSortOrder(sortOrder);
    setTempCategories(selectedCategories);
    setTempSalaryRange(salaryRange);
  }, [open]);

  const handleApply = () => {
    // Apply all temporary values to main state
    setSortBy(tempSortBy);
    setSortOrder(tempSortOrder);
    setSelectedCategories(tempCategories);
    // setSalaryRange(tempSalaryRange);



    let val1: any = tempSalaryRange[0];
    let val2 = tempSalaryRange[1];
    let output: [string, string];
    if (val1 != '' && val2 != '') {
      val1 = Number(val1);
      if (Math.abs(val1) > Number(val2)) {
        output = [val2, Math.abs(val1).toString()];
      }
      else {
        output = [Math.abs(val1).toString(), val2];
      }
    }
    else {
      output = [val1, val2]
    }
    setTempSalaryRange(output);
    setSalaryRange(output);


    // Update category-related state based on tempCategories
    if (tempCategories.length > 0) {
      const selectedCategoryItem = categoryList.find(
        (item) => item.id === tempCategories[0]
      );
      console.log("Selected Category Item:", selectedCategoryItem);
      if (selectedCategoryItem) {
        setSelectedCategory(
          selectedCategoryItem.id === "all" ? "all" : selectedCategoryItem.code
        );
        setShowName(selectedCategoryItem.full_name);
      }
    } else {
      setSelectedCategory("");
      setShowName("");
    }

    // Close modal and trigger API call

    setShowFilterCount(tempCategories[0] == "all" ? false : true);
    setTimeout(() => {
      onClose();
    }, 300)
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      className="mobile-filter-modal fullscreen-filter-modal"
      centered
      closable={false}
      styles={{
        body: {
          WebkitOverflowScrolling: "touch",
        }
      }}
    >
      <div
        className="mobile-filter-fullscreen"
        style={{
          height: "100dvh",
          overflowY: "auto",
          paddingBottom: 70,
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            position: "sticky",
            top: 0,
            backgroundColor: "#fff",
            zIndex: 1000,
            paddingTop: 16,
            paddingBottom: 16,
            borderBottom: "1px solid #eaeaea",
          }}
          className="mobile-filter-header"
        >
          <h3>Filter</h3>
          <button className="mobile-filter-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="mobile-filter-section">
          <div className="mobile-filter-label">Sort by</div>
          {sortOptions.map((opt) => (
            <div
              key={opt.value}
              className="custom-sort-option"
              onClick={() => {
                setTempSortOrder(opt.value);
                const selected: any = sortOptions.find(
                  (option) => opt.value === option.value
                );
                setTempSortBy(selected ? selected.data : "name");
              }}
              style={{ cursor: "pointer" }}
            >
              <span
                className={
                  tempSortOrder === opt.value
                    ? "custom-radio checked"
                    : "custom-radio"
                }
              />
              <span className="custom-sort-label">{opt.label}</span>
            </div>
          ))}
        </div>

        <div className="mobile-filter-section">
          <div className="mobile-filter-label">Categories</div>
          <div
            className="custom-green-checkbox"
            style={{ display: "flex", flexDirection: "column", gap: 8 }}
          >
            {categoryList.map((item) => (
              <Checkbox
                key={item.id}
                checked={tempCategories.includes(item.id)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setTempCategories([item.id]);
                  } else {
                    setTempCategories([]);
                  }
                }}
              >
                {item.full_name}
              </Checkbox>
            ))}
          </div>
        </div>

        <div className="mobile-filter-section">
          <div className="mobile-filter-label">Salary</div>
          <Slider
            range
            min={parseFloat(CONSTANT.MIN_SALARY)}
            max={parseFloat(CONSTANT.MAX_SALARY)}
            step={1000}
            value={[Number(tempSalaryRange[0]), Number(tempSalaryRange[1])]}
            tooltip={{ formatter: (v) => <div className="notranslate">{`$${v}`}</div> }}
            onChange={handleSalaryChange}
            className="custom-salary-slider"
            styles={{
              handle: {
                color: "#169c16",
                borderColor: "#169c16",
                backgroundColor: "#169c16",
              },
              track: {
                backgroundColor: "#169c16",
              },
              rail: {
                backgroundColor: "#E2E8F0",
              },
            }}
          />
          <div className="mobile-salary-inputs">
            <input
              className="salary-input"
              type="number"
              min={parseFloat(CONSTANT.MIN_SALARY)}
              max={tempSalaryRange[1]}
              value={tempSalaryRange[0]}

              onChange={(e: any) => {

                const val1 = e.target.value;
                const val2 = tempSalaryRange[1];
                if (parseFloat(val1) > parseFloat(CONSTANT.MAX_SALARY)) {
                  setTempSalaryRange([CONSTANT.MAX_SALARY, tempSalaryRange[1]])
                  return;
                }
                setTempSalaryRange([val1, val2])



              }}

            />
            <span className="salary-separator">-</span>
            <input
              className="salary-input"
              type="number"
              min={tempSalaryRange[0]}
              max={parseFloat(CONSTANT.MAX_SALARY)}
              value={tempSalaryRange[1]}
              onChange={(e: any) => {



                const val1 = e.target.value;
                if (parseFloat(val1) > parseFloat(CONSTANT.MAX_SALARY)) {
                  setTempSalaryRange([tempSalaryRange[0], CONSTANT.MAX_SALARY])
                  return;
                }
                const val2 = tempSalaryRange[0];

                setTempSalaryRange([val2, val1])
              }}


            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 6,
            }}
          >
            <span>Min: <div className="notranslate">{formatGlobalPrice(tempSalaryRange[0])}</div></span>
            <span>Max: <div className="notranslate">{formatGlobalPrice(tempSalaryRange[1])}</div></span>
          </div>
        </div>

        <div className="mobile-filter-footer">
          <button className="clear-btn" onClick={handleClearAll}>
            Clear all
          </button>
          <button className="apply-btn" onClick={handleApply}>
            Apply
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default FilterModal;
